import { IonBadge, IonItem, IonLabel, IonList, IonRadio, IonRadioGroup } from '@ionic/react';
import StepLayout, { STEP_TITLE_ID } from './StepLayout';
import { modalToggleStore, permitFormStore, permitsStore } from '../../../store/Store';

const periodLabel = (valid) => {
    if (valid === '30') {
        return 'month';
    }
    if (valid === '365') {
        return 'year';
    }
    return '';
};

const ApplyPermit2 = () => {
    const permitForm = permitFormStore.useState((s) => s.permitForm);
    const permitTypes = permitsStore.useState((s) => s.permitTypes);
    const activeTypes = permitTypes.filter((permitType) => permitType.active);
    const hasType = activeTypes.some((permitType) => permitType.name === permitForm.type);

    // Selecting via keyboard fires the change event but not a click, so the
    // validity period is recorded here rather than on the item's onClick.
    const chooseType = (name) => {
        const chosen = permitTypes.find((permitType) => permitType.name === name);
        permitFormStore.update((s) => {
            s.permitForm = { ...s.permitForm, type: name };
        });
        if (chosen) {
            permitsStore.update((s) => {
                s.currentTypeValid = chosen.valid;
            });
        }
        modalToggleStore.update((s) => {
            s.permitTypeEmpty = !chosen;
        });
    };

    const openThirdPage = () => {
        modalToggleStore.update((s) => {
            s.permitPage = 3;
        });
    };

    return (
        <StepLayout
            title='Choose permit type'
            primaryLabel='Continue'
            onPrimary={openThirdPage}
            primaryDisabled={!hasType}
            hint={hasType ? undefined : 'Select a permit type to continue.'}
        >
            <IonRadioGroup
                value={permitForm.type}
                onIonChange={(e) => chooseType(e.detail.value)}
                aria-labelledby={STEP_TITLE_ID}
            >
                <IonList lines='full'>
                    {activeTypes.map((permitType, i) => {
                        const period = periodLabel(permitType.valid);
                        return (
                            <IonItem key={`${permitType.name}-${i}`}>
                                <IonRadio slot='start' color='tertiary' value={permitType.name} />
                                <IonLabel className='ion-text-wrap'>
                                    <strong>{permitType.name}</strong>
                                    <span className='flow-choice__detail'>{permitType.desc}</span>
                                </IonLabel>
                                <IonBadge className='flow-badge' slot='end'>
                                    ${permitType.cost}
                                    {period && ` / ${period}`}
                                </IonBadge>
                            </IonItem>
                        );
                    })}
                </IonList>
            </IonRadioGroup>
            <p>
                Please contact the Fire Chief or Fire Prevention Officer at the Parry Sound Fire
                Department @ <a href='tel:+17057462262'>705-746-2262</a> if you are requesting
                approval for a fire that does not comply with the regulations for an outdoor fire
                place permit.
            </p>
        </StepLayout>
    );
};

export default ApplyPermit2;
